<div class="filter-option-buttons" *ngIf="options?.length">
  <div class="filter-label" *ngIf="label">{{ label }}</div>

  <div class="button-list">
    <button
      type="button"
      class="option-button"
      *ngFor="let option of options; trackBy: trackByValue"
      [class.selected]="isSelected(option)"
      (click)="selectOption(option)">
      {{ formatOption(option) }}
    </button>
  </div>
</div>
